import { Controller } from 'stimulus';
import Clipboard from 'clipboard';

export default class CopyrightLinkController extends Controller {
  static targets = ['tooltipCopied', 'linkSource']

  connect() {
    /* Check for IE11 */
    if (window.clipboardData) return;

    this.clipboard = new Clipboard("[data-action~='click->copyright-link#copyText']", {
      text: () => this.returnCopyrightLinkText(),
    });
  }

  disconnect() {
    if (window.clipboardData) return;

    this.clipboard.destroy();
  }

  copyText() {
    this.showCopied();

    /* IE11 */
    if (window.clipboardData) {
      window.clipboardData.setData('Text', this.returnCopyrightLinkText());
    }
  }

  showCopied() {
    setTimeout(() => {
      this.tooltipCopiedTarget.classList.add('show-copied');
    }, 100);
    setTimeout(() => {
      this.tooltipCopiedTarget.classList.add('float-away-copied');
    }, 2000);
    setTimeout(() => {
      this.tooltipCopiedTarget.classList.remove('float-away-copied', 'show-copied');
    }, 3000);
  }

  returnCopyrightLinkText() {
    return this.linkSourceTarget.textContent.trim();
  }
}
